export default __webpack_public_path__ + "static/media/pgb.41bc27d0.png";